const buttons = document.querySelectorAll('[data-bar-content]');
    if (buttons.length) {
        buttons.forEach((button) => {
            button.addEventListener('click', (event) => {
                event.preventDefault();
                if (event.target.nextSibling.classList.contains('show')) {
                    event.target.nextSibling.classList.remove('show');
                    document.querySelector('body').classList.remove('show-sidebar-content');
                } else {
                    event.target.nextSibling.classList.add('show');
                    document.querySelector('body').classList.add('show-sidebar-content');
                }
            })
        });
        document.querySelectorAll('[data-close-content-sidebar]').forEach((button) => {
            button.addEventListener('click', (event) => {
                event.target.closest('.bottom-bar--content').classList.remove('show');
            });
        })
    }
    $('body').addClass('sticky-toolbar-mobile');